<div class="ms-wrapper" [class.disabled]="disabled" [class.open]="isOpen">

  <div class="ms-input" (click)="toggleDropdown()">
    <ng-container *ngIf="(selected?.length || 0) > 0; else placeholderTpl">
      <span class="ms-badge" *ngFor="let item of selected; trackBy: trackByItem">
        {{ getDisplay(item) }}
        <button type="button" class="ms-badge-x" (click)="removeItem(item, $event)" *ngIf="!disabled" aria-label="Quitar selección">
          <svg viewBox="0 0 24 24" width="10" height="10"><path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
        </button>
      </span>
    </ng-container>
    <ng-template #placeholderTpl>
      <span class="ms-placeholder">{{ placeholder }}</span>
    </ng-template>
    <span class="ms-caret" [class.up]="isOpen">
      <svg viewBox="0 0 24 24" width="12" height="12"><path fill="currentColor" d="M7 10l5 5 5-5z"/></svg>
    </span>
  </div>

  <div class="ms-dropdown" *ngIf="isOpen">
    <div class="ms-search" *ngIf="showSearch">
      <input type="text"
             class="form-control"
             [(ngModel)]="filter"
             (click)="$event.stopPropagation()"
             placeholder=">_ Filtrar..." />
    </div>

    <ul class="ms-list">
      <li *ngFor="let item of filteredItems; trackBy: trackByItem"
          class="ms-item"
          [class.selected]="isSelected(item)"
          (click)="toggleItem(item, $event)">
        <span class="ms-check">
          <svg *ngIf="isSelected(item)" viewBox="0 0 24 24" width="14" height="14"><path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
        </span>
        <span class="ms-label">{{ getDisplay(item) }}</span>
      </li>
      <li *ngIf="filteredItems.length === 0" class="ms-empty">
        >_ Sin coincidencias
      </li>
    </ul>
  </div>

</div>